var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2931 5.22853C21.6837 4.83801 21.6837 4.20485 21.2931 3.81432L20.6859 3.20711C20.2954 2.81658 19.6622 2.81658 19.2717 3.20711L12.0002 10.4786L4.72878 3.20711C4.33825 2.81658 3.70509 2.81658 3.31457 3.20711L2.70735 3.81432C2.31683 4.20485 2.31683 4.83801 2.70735 5.22854L9.97881 12.5L2.70735 19.7715C2.31683 20.162 2.31683 20.7952 2.70735 21.1857L3.31457 21.7929C3.70509 22.1834 4.33826 22.1834 4.72878 21.7929L12.0002 14.5214L19.2717 21.7929C19.6622 22.1834 20.2954 22.1834 20.6859 21.7929L21.2931 21.1857C21.6837 20.7952 21.6837 20.162 21.2931 19.7715L14.0217 12.5L21.2931 5.22853Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.4b1e427a.svg";
export { ForwardRef as ReactComponent };